import { render, staticRenderFns } from "./ByelawsStandardsForm.vue?vue&type=template&id=d143f2b4&scoped=true&"
import script from "./ByelawsStandardsForm.vue?vue&type=script&lang=js&"
export * from "./ByelawsStandardsForm.vue?vue&type=script&lang=js&"
import style0 from "./ByelawsStandardsForm.vue?vue&type=style&index=0&id=d143f2b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d143f2b4",
  null
  
)

export default component.exports